/* sagas/record_user_logout.ts ------------------------------------- */
import { call, take }  from 'redux-saga/effects';
import axios, { AxiosResponse } from 'axios';
import { pingLogout }  from '../utils/lrs';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/recordUserLogout.php';
const isDev    = process.env.NODE_ENV === 'development';

type LogoutAction = {
  type: 'RECORD_USER_LOGOUT';
  payload: {
    userId:     string;
    semelMosad: string;
    [k: string]: any;
  };
};

export default function* recordLogoutEvent(): Generator {
  while (true) {
    /* 1 ─ wait for logout action */
    const action = (yield take('RECORD_USER_LOGOUT')) as LogoutAction;

    /* 2 ─ add timestamp */
    const payload = { ...action.payload, timestamp: new Date().toISOString() };

    try {
      console.log('[SAGA] RECORD_USER_LOGOUT', payload);

      /* 3 ─ thin ping to LRS */
      yield call(pingLogout, payload.userId, payload.semelMosad);

      /* 4 ─ legacy PHP endpoint (prod only) */
      if (!isDev) {
        const res = (yield call(axios.post, endpoint, payload)) as AxiosResponse;
        console.log('[SAGA] recordUserLogout.php ⇒', res.status);
      }
    } catch (err) {
      console.error('[SAGA] logout error', err);
    }
  }
}
